import { render, staticRenderFns } from "./SongTypeField.vue?vue&type=template&id=05665841"
import script from "./SongTypeField.vue?vue&type=script&lang=js"
export * from "./SongTypeField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports